import { support } from 'shared/utils/data'
import { Modal, Form, Select } from 'antd'
import useForm from 'shared/hooks/useForm'
import { rpc } from 'shared/utils/api'
import PropTypes from 'prop-types'
import schema from 'schema'
import React from 'react'

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 5 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 19 }
  }
}

const EditTeacherSupportModal = ({ user, onOk, ...rest }) => {
  const { handleSubmit, getFieldProps, getFieldError, isSubmitting } = useForm({
    onSubmit: async vals => {
      await rpc('user.editUser', vals)
      onOk()
    },
    initialValues: {
      name: user.name,
      id: user.id,
      support: user.support,
    },
    validationSchema: schema.user.editUser
  })

  return (
    <Modal
      {...rest}
      confirmLoading={isSubmitting}
      title='Edit Teacher Support'
      okText='Save'
      onOk={handleSubmit}>
      <Form {...formItemLayout}>
        <Form.Item {...getFieldError('support')} label='Support'>
          <Select
            {...getFieldProps('support', 'select')}
            placeholder='Select a support level'>
            {support.map(({ label, value }) => (
              <Select.Option key={value} value={value}>
                {label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  )
}

EditTeacherSupportModal.propTypes = {
  user: PropTypes.object
}

export default EditTeacherSupportModal
